/**
 * Locations Catalog Mapper
 */

import type { LC_LocationItem, Location } from './locations.types';

/**
 * Map LC_LocationItem to Location
 */
export function mapLocationOutToModel(item: LC_LocationItem): Location {
  return {
    id: item.locationId,
    name: item.locationName,
    address: item.address,
    latitude: item.latitude,
    longitude: item.longitude,
  };
}
